import { IAPIResponseError, IError } from '@checkout/errors';
import { ICountryChangeRequestPayload, ICountryChangeSuccessPayload, ICountryStateChangePayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { CountryStateChangeRequestAction, RootAction } from '../actions/actionTypes.d';
import { getStatesItems } from '../utils/address';
import convertMessages from '../utils/convertErrors';
import { FormNames } from '../utils/formNames';
import { ingridResume, ingridSuspend } from '../utils/widgets';
import ActionTypes from './../actions/actionTypes';
import { CountryChangeRequestAction } from './../actions/actionTypes.d';
import {
  countryChangeRequest,
  countryChangeSuccess,
  countryStateChangeRequest,
  countryStateChangeSuccess,
  fetchKCOWidgetRequest,
  responseError,
  setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';
import { isKlarnaCheckout } from './../utils/paymentMethods';

export const changeCountryEpic: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.ofType(ActionTypes.COUNTRY_CHANGE_REQUEST)
  .mergeMap((action: CountryChangeRequestAction) => {
    ingridSuspend();
    return fromPromise$(rest.httpPut(`/countries/${action.payload.countryCode}`))
      .flatMap((response: AxiosResponse<ICountryChangeSuccessPayload>) => {
        const payload = Object.assign(response.data, { formName: action.payload.formName });
        const { paymentMethod } = response.data.selection;

        ingridResume();

        if (isKlarnaCheckout(paymentMethod)) {
          return of$(fetchKCOWidgetRequest()).startWith(countryChangeSuccess(payload));
        }
        return of$(countryChangeSuccess(payload));
      })
      .catch((error: IError) => {
        logger(error);
        return of$(setErrors(error));
      });
  });

export const changeCountryStateEpic: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.ofType(ActionTypes.COUNTRY_STATE_CHANGE_REQUEST)
  .mergeMap((action: CountryStateChangeRequestAction) => {
    return rest.httpPut(`/countries/${action.payload.countryCode}/states/${action.payload.stateCode}`)
    .then((response: AxiosResponse<ICountryChangeSuccessPayload>) => {
      const payload = Object.assign(response.data, { formName: action.payload.formName });

      return countryStateChangeSuccess(payload);
    })
    .catch((error: IError) => {
      logger(error);
      if (error.response && error.response.data && error.response.data.selection) {
        const convertedMessages = convertMessages(error.response.data, state$.value.checkout.intlData);
        const responseApiErrorPayload: IAPIResponseError = {
          errors: convertedMessages,
          selection: error.response.data.selection,
        };
        return responseError(responseApiErrorPayload);
      }
      return setErrors(error);
    });
  });

/*
  Fired countryChangeRequest or countryStateChangeRequest when PRESELECT_INITIAL_VALUES action accurs and
  "Remember me" checkbox is checked, so we have to let the API know that user has preselected/remembered country or state
*/
export const preselectRememberedStateAndCountryEpic: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.ofType(ActionTypes.PRESELECT_INITIAL_VALUES)
  .filter(() => state$.value.checkout.fieldsData.rememberMe !== undefined && state$.value.checkout.fieldsData.rememberMe &&
    (state$.value.checkout.location.country !== state$.value.checkout.fieldsData.shippingAddress.country))
  .mergeMap(() => {

    if (getStatesItems(state$.value.checkout.countries, state$.value.checkout.fieldsData.shippingAddress.country)) {
      const stateChangePayload: ICountryStateChangePayload = {
        countryCode: state$.value.checkout.fieldsData.shippingAddress.country,
        stateCode: state$.value.checkout.fieldsData.shippingAddress.state,
        formName: FormNames.shippingAddress
      };
      return  of$(countryStateChangeRequest(stateChangePayload));
    }

    const countryChangePayload: ICountryChangeRequestPayload = {
      countryCode: state$.value.checkout.fieldsData.shippingAddress.country,
      formName: FormNames.shippingAddress
    };

    return  of$(countryChangeRequest(countryChangePayload));
  });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/countries.ts